import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from './authentication.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit, OnDestroy {
  isLoading = false;

  constructor(private authenticationService: AuthenticationService, private router: Router) {}

  ngOnInit(): void {
    this.callByRoute();
  }

  ngOnDestroy(): void {
    // Needed for automatic unsubscribe with untilDestroyed
  }

  callByRoute(): void {
    this.isLoading = true;
    const { url }: { url: string } = this.router;
    switch (url) {
      case '/login':
        this.authenticationService.logIn();
        this.router.navigate(['/']);
        break;
      case '/register':
        this.authenticationService.register();
        this.router.navigate(['/']);
        break;
      case '/logout':
        this.authenticationService.logOut();
        this.router.navigate(['/']);
        break;
      default:
        break;
    }
  }
}
